<div class="tw-px-4 tw-pb-6">
  <div class="tw-bg-white tw-w-full tw-rounded-4 tw-font-body tw-shadow-z4">
    <!-- bell and text container -->
    <div class="tw-p-4 tw-flex tw-gap-3">
      <!-- gif-->
      <div class="tw-flex-shrink-0">
        <img class="tw-w-10" src="/assets/gifs/notification-green-bell.gif" alt="notification bell animations"/>
      </div>
      <div class="">
        <h2 class="tw-font-[700] tw-text-500">Want to stay updated?</h2>
        <p class="tw-text-200 tw-text-gray-500">Enable notifications now to get updates on your orders, check-ups &amp; more</p>
      </div>
    </div>
    <!--  cta container-->
    <div class="tw-text-300 tw-flex tw-border-t-[1px] tw-border-gray-200 tw-divide-x-[1px]">
      <div class="tw-text-gray-400 tw-flex-1 tw-text-center tw-pb-[8.5px] tw-pt-[7.5px]" (click)="onClose()">Maybe later</div>
      <div class="tw-text-teal-600 tw-font-[700] tw-flex-1 tw-text-center tw-pb-[8.5px] tw-pt-[7.5px]" (click)="onEnable()">Enable</div>
    </div>
  </div>
</div>
